import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation, gql } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ApiError from '@/lib/shared-coms/ApiError';
import PlaceholderStocking from './PlaceholderStocking';
import { useRootStore } from '@/lib/providers/RootProvider';

const PURCHASE_ORDER = gql`
  query purchaseOrder($id: ID!, $clientId: ID!) {
    purchaseOrder(id: $id, clientId: $clientId) {
      id
      clientPurchaseOrderNumber
      orderItems {
        id
        productId
        quantity
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
        }
      }
      vendor {
        id
        companyName
      }
    }
  }
`;

const STOCK_PLACEHOLDER_INVENTORY = gql`
  mutation stockPlaceholderInventory(
    $id: ID!
    $allocations: [PlaceholderStockAllocationAttributes!]!
    $companyId: ID!
  ) {
    stockPlaceholderInventory(id: $id, allocations: $allocations, companyId: $companyId) {
      id
      clientStatus
    }
  }
`;

function PlaceholderStockingData(props) {
  const clientId = useRootStore((state) => state.selectedCompany.id);
  const [stockPlaceholderInventory] = useMutation(STOCK_PLACEHOLDER_INVENTORY);
  const { purchaseOrderId } = useParams();
  const { data, error, loading, refetch } = useQuery(PURCHASE_ORDER, {
    variables: { id: purchaseOrderId, clientId },
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const { purchaseOrder } = data || {};
  if (!purchaseOrder) return <ApiError error={new Error('Order not found') as any} />;

  return (
    <PlaceholderStocking
      purchaseOrder={purchaseOrder}
      stockPlaceholderInventory={stockPlaceholderInventory}
      clientId={clientId}
      refetch={refetch}
      {...props}
    />
  );
}

export default PlaceholderStockingData;
